const validateEmail = function(element){

    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/

    return regex.test(element.value)

}

export default validateEmail